import {h} from 'preact';
import UEStatusMeter from '../UEStatusMeter';
import UEStatusBadge from '../UEStatusBadge';

const Loading = props =>
    <div className={props.className}>
        <p className="flex-1 text-lg text-center loading">Loading...</p>
    </div>;

const Content = ( {ueStatus, className, ...props} ) =>
    <div className={className}>
        {ueStatus.currentRank &&
        <div className="text-center flex-1">
            <p className="font-bold my-2">Current Status</p>
            <UEStatusBadge {...props} {...ueStatus} />
        </div>
        }
        <div className="text-center flex-1">
            <p className="font-bold my-2">2019 Progress</p>
            <UEStatusMeter {...props} {...ueStatus} />
        </div>
    </div>;

export default {
    Loading,
    Content
};
